// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_13-counter {
  /* Typography */
  --perxis-auto-counter-font-size-inner: var(
    --perxis-auto-counter-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-counter-color-inner: var(
    --perxis-auto-counter-color,
    var(--perxis-auto-root-typography-color-dark-light-inner)
  );
  --perxis-auto-counter-count-font-family-inner: var(
    --perxis-auto-counter-count-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --perxis-auto-counter-count-font-size-inner: var(
    --perxis-auto-counter-count-font-size,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-counter-count-font-weight-inner: var(--perxis-auto-counter-count-font-weight, 700);
  --perxis-auto-counter-count-letter-spacing-inner: var(
    --perxis-auto-counter-count-letter-spacing,
    --perxis-auto-root-typography-small-letter-spacing-inner
  );
  --perxis-auto-counter-count-color-inner: var(
    --perxis-auto-counter-count-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-counter-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-counter-font-size-inner);
  --perxis-auto-typography-color-dark-light: var(--perxis-auto-counter-color-inner);
}
.perxis-auto-1_16_13-counter.perxis-auto-1_16_13-typography {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: start;
  align-items: baseline;
  gap: 4px;
}
.perxis-auto-1_16_13-counter__count {
  --perxis-auto-typography-small-font-size-xxs: var(--perxis-auto-counter-count-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--perxis-auto-counter-count-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--perxis-auto-counter-count-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--perxis-auto-counter-count-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--perxis-auto-counter-count-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--perxis-auto-counter-count-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--perxis-auto-counter-count-font-size-inner);
  --perxis-auto-typography-small-font-family: var(--perxis-auto-counter-count-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--perxis-auto-counter-count-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--perxis-auto-counter-count-letter-spacing-inner);
  --perxis-auto-typography-color-darkest: var(--perxis-auto-counter-count-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
